import { Alert, Box, CircularProgress } from "@mui/material";
import { useVersionDiff } from "../hooks/useVersions";
import { UploadDiffSummary } from "./UploadDiffSummary";

interface VersionDiffViewProps {
  projectId: string;
  versionAId: string;
  versionBId: string;
}

/**
 * Inline diff viewer — reuses UploadDiffSummary for the actual rendering so
 * the two views (just-after-upload vs. history diff) look and behave the same.
 */
export function VersionDiffView({
  projectId,
  versionAId,
  versionBId,
}: VersionDiffViewProps) {
  const { data, isLoading, error } = useVersionDiff(
    projectId,
    versionAId,
    versionBId,
  );

  if (isLoading) {
    return (
      <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (error) {
    return <Alert severity="error">Failed to load diff: {error.message}</Alert>;
  }

  if (!data) return null;

  return (
    <UploadDiffSummary
      diff={data.diff}
      versionNumber={data.to.version_number}
      semverLabel={data.to.semver_label}
      status="created"
    />
  );
}
